import { Component, input } from '@angular/core';

/** White rounded surface (design card). `flush` removes padding for list rows that span the card. */
@Component({
  selector: 'mbm-card',
  templateUrl: './mbm-card.component.html',
  styleUrl: './mbm-card.component.scss',
  host: { '[class.mbm-card-flush]': 'flush()' },
})
export class MbmCardComponent {
  readonly flush = input(false);
}
